import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import { Event, PagePageDynamicDynamicZone, Technology, Testimony } from '../../../types/schema';
import { AvailableJobItemProps } from '../../ui/AvailableJobItem';
import { SEO } from '../../../utils/SEO';
import CustomPageTemplate from './template';

type CustomPageProps = {
  technologies: Technology[];
  testimonies: Testimony[];
  events: Event[];
  pageDynamic: PagePageDynamicDynamicZone[];
  metaTitle?: string;
  metaDescription?: string;
  metaImage?: string;
  hideAppMastersTitle?: boolean;
  language?: string;
  jobs?: AvailableJobItemProps[];
};

const CustomPage: React.FC<CustomPageProps> = ({
  metaTitle,
  metaDescription,
  metaImage,
  hideAppMastersTitle,
  ...props
}) => {
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000/';
  const router = useRouter();
  const itemListElements = [
    {
      position: 1,
      name: 'App Masters',
      item: siteUrl,
    },
    {
      position: 2,
      name: metaTitle as string,
      item: (siteUrl + router.locale + router.asPath) as string,
    },
  ];

  return (
    <>
      <NextSeo
        {...SEO({
          pathname: router.asPath,
          locale: router.locale as string,
          title: metaTitle as string,
          description: metaDescription as string,
          image: metaImage as string,
          hideAppMastersTitle: hideAppMastersTitle as boolean,
        })}
      />
      <BreadcrumbJsonLd itemListElements={itemListElements} />

      <CustomPageTemplate {...props} />
    </>
  );
};

export default CustomPage;
